// extracted by mini-css-extract-plugin
export default {"Opps":"opps_Opps__0RiWx","OppsButton":"opps_OppsButton__MlnDR","text":"opps_text__6UPH-"};